import { DrinkFrequency } from "@dcc/types/drinkFrequency";
import { Gender } from "@dcc/types/gender";
import { UnitAndCalories } from "@dcc/types/drinkingDay";
import { getMonthlyPercentageOfPopulation } from "@dcc/score/monthlyPercentagePopulation";
import { getPercentageOfPopulation } from "@dcc/lookup/unitdistribution/unitdistribution";

export const getPercentWhoDrinkLess = ({
  gender,
  drinkFrequency,
  weeklyUnitsAndCalories
}: {
  gender: Gender | undefined;
  drinkFrequency: DrinkFrequency | undefined;
  weeklyUnitsAndCalories: UnitAndCalories;
}) => {
  if (gender === undefined) {
    return 0;
  }

  if (
    drinkFrequency === DrinkFrequency.Monthly ||
    drinkFrequency === DrinkFrequency.TwiceMonthly
  ) {
    return getMonthlyPercentageOfPopulation(gender, drinkFrequency);
  }
  return getPercentageOfPopulation(gender, weeklyUnitsAndCalories.units) || 0;
};
